(function ($) {
    $(document).ready(function () {

        /**
         * Pagination test to hide loading gif
         */
        $('.paginate_button').on('click', function(){
            $('.loading-indicator').removeClass('show');
        });
        $('select[name=campaign-order-list_length]').on('click',function(){
            $('.loading-indicator').removeClass('show');
        });


        /**
         * Select All
         * 
         */
        $('.target-select-all-bulk').on('click', function(){
            if($(this).prop('checked') === true){
                $('.bulkstatus-target').prop('checked', true);
            }
            if($(this).prop('checked') === false){
                $('.bulkstatus-target').prop('checked', false);
            }
            
        });

        /**
         * Single Order Status Change
         */

        $('.single-status-select-target').on('change',function(){
            let order_id = $(this).attr('data-order-id');
            let status = $(this).val();
            $.ajax({
                url: "/wp-json/wewo/v2/bulk-status-update-campaign",
                method: "POST",
                data: {
                    single_order_id: order_id,
                    single_status: status
                },
                beforeSend: function () {
                    $('.loading-indicator').addClass('show');
                },
                success: function (result) {
                    $('.loading-indicator').removeClass('show');
                },
                error: function (er) {
                    console.log(er);
                },
            });
        });

        /**
         * Bulk Form Submit
         */
        $('#campaign-bulk-update-form').submit(function (event) {
            event.preventDefault();
            let data = $('#campaign-bulk-update-form :input').serializeArray()
            $.ajax({
                url: "/wp-json/wewo/v2/bulk-status-update-campaign",
                method: "POST",
                data: {
                    submitted_data:data
                },
                beforeSend: function () {
                    $('.loading-indicator').addClass('show');
                },
                success: function (result) {
                    $('.loading-indicator').removeClass('show');
                    let url = window.location.href
                    window.location.href = url;

                },
                error: function (er) {
                    console.log(er);
                },
            });
        });

    });
})(jQuery);